export default __webpack_public_path__ + "static/media/gallery-6.c6aaa998.jpg";